import { queryOptions, useQuery } from "@tanstack/react-query";

import { getStripeKeysPublishableKey } from "api/methods";
import Services from "services/Services";

export function useStripePublishableKey(): string | null {
  const { data } = useQuery(
    queryOptions({
      queryKey: getStripeKeysPublishableKey.key(),
      queryFn: async () => {
        const authToken = await Services.auth.getToken();

        if (!authToken) {
          return null;
        }

        return getStripeKeysPublishableKey();
      },
      retry: 3,
      retryDelay: (attemptIndex: number) => Math.min(1000 * 2 ** attemptIndex, 10000),
    }),
  );

  return data ?? null;
}
